import { sleep } from "../../assets/js/utils/timeout.js";

export async function showHinweis(messageid, notificationContainer, parent = "MerkzettelHinweis") {
    await sleep(100);
    const hinweis = document.createElement("merkzettel-hinweis");
    if (typeof hinweis.render !== "function") {
        console.info("MerkzettelHinweis is not defined - please make sure the component is loaded");
        return;
    }
    try {
        hinweis.render(notificationContainer, messageid);
        await sleep(100);
        hinweis.open();
    } catch (error) {
        console.error(parent, "showHinweis", error);
    }
}
